import React from "react";
import Grid from "@mui/material/Grid";
import ActivityInfo from "./ActivityInfo";
import CircleIcon from "../CircleIcon/CircleIcon";
import { getActivityAnchor, getActivityIcon } from "../../services/Activities/activityTypes";
import { ACTIVITY_OVERDUE } from "../../services/Activities/ActivityStatus";
import { ReportProblemOutlined } from "@mui/icons-material";
import ActivityActions from "./ActivityActions/ActivityActions";
import ActivityNote from "./ActivityNote";
import { HashLink } from "react-router-hash-link";
import { SxProps } from "@mui/material";
import { Activity as ActivityType } from "../../types/Activity";
import { ProductUnion } from "../../types/ProductUnion";
import activitiesStyle from "./activitiesStyle";

type ActivityProps = {
  activity: ActivityType<string>;
  product: ProductUnion;
  updateActivities: () => void;
};

const Activity = ({ activity, product, updateActivities }: ActivityProps) => {
  if (!activity) {
    return null;
  }

  const getMandatoryOrOverdueSx = (activity: ActivityType): SxProps => {
    if (activity.activityStatus === ACTIVITY_OVERDUE) {
      return {
        color: "error.main",
      };
    }
    if (activity.mandatory) {
      return {
        color: "warning.light",
      };
    }
    return null;
  };

  const icon = getActivityIcon(product.productClassName, activity.type);
  const anchor = getActivityAnchor(product.productClassName, activity.type);

  const anchorProps = anchor ? { component: HashLink, to: anchor } : {};

  return (
    <>
      <Grid container>
        <Grid {...anchorProps} sx={{ display: { xs: "none", sm: "block", width: 72 } }}>
          <CircleIcon icon={icon} type={"muiIcon"} />
        </Grid>
        <Grid sx={{ width: "calc(100% - 72px)" }}>
          <Grid
            container
            sx={{
              alignItems: "flex-start",
              height: "100%",
              flexWrap: { lg: "noWrap" },
            }}
          >
            <Grid sx={{ fontSize: "1rem", marginRight: "1rem", flexShrink: 1, ...getMandatoryOrOverdueSx(activity) }}>
              {activity.subject}
            </Grid>
            {activity.mandatory && (
              <Grid sx={{ padding: "0 0.5rem" }}>
                <ReportProblemOutlined />
              </Grid>
            )}
            <Grid sx={activitiesStyle.noteContainer}>
              <ActivityInfo activity={activity} />
            </Grid>
            <Grid sx={{ minWidth: 180 }}>
              <ActivityActions activity={activity} updateActivities={updateActivities} product={product} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ActivityNote noteContent={activity.note} />
    </>
  );
};

export default Activity;
